// LABEL
export const LABEL_SOLICITAR_USUARIO = 'Solicitar usuario';
export const LABEL_NOMBRE_COMPLETO = 'Nombre completo';
export const LABEL_CARGO = 'Cargo';
export const LABEL_DEPENDENCIA = 'Dependencia';
export const LABEL_ZONAL = 'Zonal';
export const LABEL_ENVIAR_SOLICITUD = 'Solicitar';

// MENSAJES
export const MSJ_INGRESE_NOMBRE_COMPLETO = 'Ingrese su nombre completo';
export const MSJ_INGRESE_CARGO = 'Ingrese su cargo';
export const MSJ_INGRESE_DEPENDENCIA = 'Ingrese su dependencia';
export const MSJ_INGRESE_ZONAL = 'Seleccione su zonal';

// PLACEHOLDER
export const PCHR_EJM_COMERCIAL = 'EJM: Comercial';

// VALUES
export const LISTA_ZONAL = [
    {
        id: 1,
        nombre: 'PIURA'
    },
    {
        id: 4,
        nombre: 'MORROPON'
    },
    {
        id: 5,
        nombre: 'PAITA'
    },
    {
        id: 6,
        nombre: 'SULLANA'
    },
    {
        id: 7,
        nombre: 'TALARA'
    }
];